@let navigationItemText = 'navigation.items.' + navigationItem().id | translate;
@let isMenuCollapsedValue = isMenuCollapsed();
@let isMobileViewValue = isMobileView();
@let isNavigationItemCollapsedValue = isNavigationItemCollapsed();

<ng-container *itcFeature="navigationItemFeatures()">
  <ng-container *itcCountryAccess="navigationItemAccessibleCountries()">
    <ng-container *itcPermission="navigationItemPermissions()">
      <div
        class="navigation-expandable-item"
        (mouseleave)="hideNavigationPanelOnMouseLeave()"
        (mouseenter)="showNavigationPanel()"
        (keydown.escape)="closeNavigationPanelFromKeyboard()"
        (focusout)="hideNavigationPanelOnFocusOut($event)"
      >
        <button
          #menuButton
          type="button"
          class="navigation-expandable-item__menu"
          [class.navigation-expandable-item__menu--active]="isChildItemActive() && isMenuCollapsedValue && !isMobileViewValue"
          [attr.aria-expanded]="isExpanded()"
          (click)="handleMenuClick()"
        >
          <i aria-hidden="true" class="navigation-expandable-item__icon" [class]="navigationItem().iconClass"></i>
          <span class="navigation-expandable-item__text" [class.navigation-expandable-item__text--active]="isChildItemActive()">
            {{ navigationItemText }}
          </span>

          @if (isMenuCollapsedValue && isChildItemLoading()) {
            <div class="navigation-expandable-item__spinner">
              <kds-spinner variant="overlay" />
            </div>
          }

          @if (!isMenuCollapsedValue || isMobileViewValue) {
            <i
              aria-hidden="true"
              class="navigation-expandable-item__toggle-icon fa-regular fa-chevron-down"
              [class.navigation-expandable-item__toggle-icon--expanded]="!isNavigationItemCollapsedValue"
            ></i>
          }
        </button>

        @if (!isNavigationItemCollapsedValue && (!isMenuCollapsedValue || isMobileViewValue)) {
          <div class="navigation-expandable-item__expandable-content" [@toggleContentFadeIn]="true" [@toggleContentFadeOut]="true">
            <ng-container *ngTemplateOutlet="childNavigationItems" />
          </div>
        }

        @if (isNavigationPanelShown()) {
          <div
            #panel
            class="navigation-expandable-item__panel"
            (keydown.arrowDown)="moveFocus($event, MenuNavigationDirection.Next)"
            (keydown.arrowUp)="moveFocus($event, MenuNavigationDirection.Previous)"
          >
            <div class="navigation-expandable-item__panel-header">{{ navigationItemText }}</div>
            <ng-container *ngTemplateOutlet="childNavigationItems" />
          </div>
        }
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #childNavigationItems>
  @for (navigationItem of navigationItem().children; track navigationItem.id) {
    <itc-left-navigation-item
      [navigationItem]="navigationItem"
      [isTooltipEnabled]="false"
      [topNavigation]="topNavigation()"
      (click)="hideNavigationPanel()"
      (navigationItemClick)="navigationItemClick.emit()"
    />
  }
</ng-template>
